var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12",class:_vm.show ? 'mb-5' : ''},[(_vm.show)?_c('h4',{staticClass:"pt-3"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.alert)?_c('v-alert'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18de95b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/includes/TitlePage.vue
// module id = null
// module chunks = 